export default {
  "about": "概要",
  "about_title": "私たちについて",
  "access_secret": "アクセスシークレット",
  "access_token": "アクセス トークン",
  "accessibility_animations": "アニメーション",
  "accessibility_contrast": "コントラスト",
  "accessibility_font_size": "フォントサイズ",
  "accessibility_title": "アクセシビリティ",
  "actions": "アクション",
  "active": "アクティブ",
  "active_ads": "アクティブ広告",
  "active_campaigns": "アクティブなキャンペーン",
  "ad_code_placeholder": "<script>...</script> または AdSense スロットコード",
  "ad_format": "広告形式",
  "ad_formats": "広告フォーマット",
  "ad_management": "広告管理",
  "ad_position_settings": "広告位置設定",
  "ad_price_list": "広告料金表",
  "ad_pricing_formats_campaigns": "価格設定、形式、キャンペーンとトラッキング",
  "add": "追加",
  "add_api_keys": "設定タブでAPIキーを追加する",
  "address": "住所",
  "admin": "管理",
  "adminPanel": "管理パネル",
  "admin_ab_testing_title": "A/Bテスト",
  "admin_accent": "アクセント",
  "admin_accent_color": "アクセントカラー",
  "admin_action": "アクション",
  "admin_activate": "有効化",
  "admin_active_feeds": "アクティブなフィード",
  "admin_active_label": "アクティブ",
  "admin_active_now": "現在アクティブ",
  "admin_active_subscribers": "アクティブな購読者",
  "admin_ad_performance": "広告パフォーマンス",
  "admin_add_feed": "フィードを追加",
  "admin_add_tag": "タグを追加",
  "admin_admins": "管理者",
  "admin_advertisements": "広告",
  "admin_advertiser_email": "広告主のメール",
  "admin_advertiser_name": "広告主名",
  "admin_affiliate_links": "アフィリエイトリンク",
  "admin_ai_content_title": "AIコンテンツ処理",
  "admin_ai_prompt_settings": "AIプロンプトとモデル設定",
  "admin_analytics_title": "分析",
  "admin_api_latency": "APIレイテンシー",
  "admin_api_server": "APIサーバー",
  "admin_article_actions": "アクション",
  "admin_article_category": "カテゴリ",
  "admin_article_published": "公開済み",
  "admin_article_selector": "記事セレクタ（CSS、例：article.news）",
  "admin_article_views": "ビュー",
  "admin_articles_count": "記事数",
  "admin_articles_title": "記事",
  "admin_author_change_failed": "著者の変更に失敗しました。",
  "admin_authors_title": "著者",
  "admin_auto": "自動",
  "admin_auto_save_draft": "自動的に下書きとして保存",
  "admin_avg_seo_score": "平均SEOスコア",
  "admin_bio": "経歴",
  "admin_blog_manage": "リッチコンテンツエディターでブログ投稿を管理",
  "admin_blog_title": "ブログ",
  "admin_brand_theme": "ブランド＆テーマ",
  "admin_branding_desc": "サイトの外観をカスタマイズ（システム管理者のみ）",
  "admin_branding_title": "リブランディングモジュール",
  "admin_breaking_ticker": "速報ティッカー",
  "admin_browser": "ブラウザ",
  "admin_browsers": "ブラウザ",
  "admin_bug_reports": "バグ報告",
  "admin_bulk_delete_failed": "一括削除に失敗しました。",
  "admin_bulk_operations": "一括操作",
  "admin_categories_grid": "カテゴリーグリッド",
  "admin_choose_gallery": "ギャラリーから選ぶ",
  "admin_churn_prediction": "離脱予測",
  "admin_classic_portal": "クラシックニュースポータル",
  "admin_classifieds": "分類広告",
  "admin_clear_log": "ログをクリア",
  "admin_click_button": "ボタンをクリック",
  "admin_collection_stats": "コレクション統計",
  "admin_color_scheme": "カラースキーム",
  "admin_columnist": "コラムニスト",
  "admin_comments": "コメント",
  "admin_competitor_monitoring": "競合モニタリング",
  "admin_confirm_action": "本当によろしいですか？",
  "admin_content_calendar_title": "コンテンツカレンダー",
  "admin_content_filter": "コンテンツフィルタ条件",
  "admin_content_stats": "コンテンツ統計",
  "admin_contributor": "寄稿者",
  "admin_coordinates": "座標",
  "admin_copy_ip": "IPアドレスをコピー",
  "admin_copy_text": "コピー",
  "admin_core_services": "コアサービス",
  "admin_countries": "国",
  "admin_cpc": "CPC (EUR)",
  "admin_crawl_now": "今すぐクロール",
  "admin_create_author": "著者を作成",
  "admin_create_manage_promo": "プロモーションコードを作成および管理",
  "admin_create_voucher": "クーポンを作成",
  "admin_custom_meta": "カスタムメタ",
  "admin_dashboard_title": "ダッシュボード",
  "admin_database": "データベース",
  "admin_db_backup": "データベースバックアップ",
  "admin_db_latency": "DBレイテンシー",
  "admin_db_name": "データベース名",
  "admin_db_size": "DBサイズ",
  "admin_default": "デフォルト",
  "admin_default_language": "デフォルト言語",
  "admin_device": "デバイス",
  "admin_devices": "デバイス",
  "admin_discount": "割引",
  "admin_disk_usage": "ディスク使用量",
  "admin_docs_api_ref": "APIリファレンス",
  "admin_docs_download_pdf": "PDFをダウンロード",
  "admin_docs_faq": "FAQ",
  "admin_docs_getting_started": "はじめに",
  "admin_docs_implemented": "実装済み",
  "admin_docs_no_pages": "ドキュメントページはまだありません",
  "admin_docs_order": "順序",
  "admin_docs_title": "ドキュメント",
  "admin_doktor_earnings": "Doktorの収益",
  "admin_draft_articles": "下書き記事",
  "admin_dynamic_pricing": "動的価格設定",
  "admin_edit_in_cms": "CMSで編集",
  "admin_editor_role": "エディター",
  "admin_export_csv": "CSVをエクスポート",
  "admin_favicon": "ファビコン",
  "admin_feed_crawler": "フィードクローラー",
  "admin_feed_name": "フィード名",
  "admin_feed_url": "フィードURL",
  "admin_feeds_title": "RSSフィード",
  "admin_file": "ファイル",
  "admin_fixed_amount": "固定額",
  "admin_frozen": "凍結",
  "admin_full_name": "フルネーム",
  "admin_general": "一般",
  "admin_google_search_console": "Googleサーチコンソール",
  "admin_grade": "等級",
  "admin_health_title": "健康状態チェック",
  "admin_high_leads": "高価値リード",
  "admin_import_title": "Croatia Timesインポートプラットフォーム",
  "admin_index_now": "IndexNow",
  "admin_integrations": "統合",
  "admin_job_postings": "求人情報",
  "admin_joined": "参加済み",
  "admin_keywords": "キーワード",
  "admin_landing_title": "ランディングページ",
  "admin_last_submissions": "最後の提出",
  "admin_live_analytics": "ライブ分析",
  "admin_live_analytics_title": "ライブ分析",
  "admin_llm_model": "LLMモデル",
  "admin_manage_feeds": "フィードを管理",
  "admin_mass_management": "大量記事管理",
  "admin_max_articles": "最大記事数",
  "admin_media_storage": "メディアストレージ",
  "admin_memory": "メモリ",
  "admin_menu_manager": "メニューマネージャー",
  "admin_meta_description": "メタ説明",
  "admin_monetization_title": "収益化ダッシュボード",
  "admin_mysql_db": "MySQLデータベース",
  "admin_mysql_host": "MySQLホスト",
  "admin_nav_ab_testing": "A/Bテスト",
  "admin_nav_ads": "広告管理",
  "admin_nav_ads_report": "広告レポート",
  "admin_nav_adsense": "AdSense設定",
  "admin_nav_advanced_analytics": "詳細分析",
  "admin_nav_affiliates": "アフィリエイトリンク",
  "admin_nav_ai_content": "AIコンテンツ処理",
  "admin_nav_amp": "AMPとGoogle Discover",
  "admin_nav_analytics": "分析",
  "admin_nav_analytics_ai": "分析 & AI",
  "admin_nav_articles": "記事",
  "admin_nav_audit_log": "監査ログ",
  "admin_nav_authors": "著者",
  "admin_nav_blog": "ブログ",
  "admin_nav_branding": "リブランディング",
  "admin_nav_breaking_news": "速報 / フラッシュニュース",
  "admin_nav_bulk_operations": "一括操作",
  "admin_nav_categories": "カテゴリ",
  "admin_nav_chat_sessions": "チャットセッション",
  "admin_nav_churn_prediction": "解約予測",
  "admin_nav_classifieds": "分類広告",
  "admin_nav_comments": "コメント",
  "admin_nav_competitor_monitoring": "競合モニタリング",
  "admin_nav_content": "コンテンツ",
  "admin_nav_content_calendar": "コンテンツカレンダー",
  "admin_nav_county_map": "郡の地図",
  "admin_nav_crypto": "暗号ウィジェット",
  "admin_nav_dashboard": "ダッシュボード",
  "admin_nav_db_backup": "データベース",
  "admin_nav_docs": "ドキュメント",
  "admin_nav_doktor_earnings": "Doktorの収益",
  "admin_nav_duplicate_detection": "重複検出",
  "admin_nav_editorial": "編集",
  "admin_nav_editorial_workflow": "編集ワークフロー",
  "admin_nav_email_campaigns": "メールキャンペーン",
  "admin_nav_feeds": "RSSフィード",
  "admin_nav_finance": "財務",
  "admin_nav_health": "システムの健康",
  "admin_nav_heatmaps": "リーディングヒートマップ",
  "admin_nav_import": "インポート",
  "admin_nav_invoices": "請求書",
  "admin_nav_job_ads": "求人広告",
  "admin_nav_landing_pages": "ランディングページ",
  "admin_nav_live_analytics": "ライブ分析",
  "admin_nav_management": "管理",
  "admin_nav_marketing": "マーケティング",
  "admin_nav_media": "メディア",
  "admin_nav_menu_manager": "メニューマネージャー",
  "admin_nav_micropayments": "マイクロペイメント",
  "admin_nav_monetization": "収益化",
  "admin_nav_newsletter": "ニュースレター",
  "admin_nav_newsletter_digest": "ニュースレターダイジェスト",
  "admin_nav_pages": "ページ",
  "admin_nav_payments": "支払い",
  "admin_nav_performance_forecast": "パフォーマンス予測",
  "admin_nav_photo_verification": "写真認証",
  "admin_nav_portal_toggle": "ポータル管理",
  "admin_nav_portals": "ポータル",
  "admin_nav_pricing": "価格設定",
  "admin_nav_promo_codes": "プロモコード",
  "admin_nav_push_notifications": "プッシュ通知",
  "admin_nav_quizzes": "クイズ",
  "admin_nav_recommendations": "コンテンツ推奨",
  "admin_nav_reports": "コンテンツレポート",
  "admin_nav_sanitization": "コンテンツ洗浄",
  "admin_nav_scheduler": "コンテンツスケジューラ",
  "admin_nav_security": "セキュリティ",
  "admin_nav_seo_dashboard": "SEOダッシュボード",
  "admin_nav_seo_distribution": "SEOと配信",
  "admin_nav_series": "シリーズ記事",
  "admin_nav_settings": "設定",
  "admin_nav_social": "ソーシャルメディア",
  "admin_nav_social_scheduler": "ソーシャルスケジューラー",
  "admin_nav_sponsored": "スポンサー付き",
  "admin_nav_sponsored_marketplace": "スポンサー・マーケットプレイス",
  "admin_nav_subscriptions": "サブスクリプション",
  "admin_nav_surveys": "調査",
  "admin_nav_syndication": "シンジケーションAPI",
  "admin_nav_system": "システム",
  "admin_nav_tips": "チップ / 寄付",
  "admin_nav_translations": "翻訳",
  "admin_nav_ugc_review": "市民コンテンツ",
  "admin_nav_users": "ユーザー",
  "admin_nav_users_subscriptions": "ユーザー & サブスクリプション",
  "admin_nav_versioning": "バージョン履歴",
  "admin_nav_vibeposao": "Times Posao ポータル",
  "admin_nav_vouchers": "バウチャー / 割引",
  "admin_nav_widgets": "ウィジェット / カタログ",
  "admin_new_author_name": "新しい著者名...",
  "admin_new_post": "新しい投稿",
  "admin_no_data": "データが利用できません",
  "admin_no_icon": "アイコンがありません",
  "admin_no_logo": "ロゴがありません",
  "admin_no_pending_reports": "保留中の報告はありません",
  "admin_no_published_articles": "公開された記事が見つかりません",
  "admin_password_field": "パスワード",
  "admin_performance_forecast": "パフォーマンス予測",
  "admin_photo_verification": "写真認証",
  "admin_plan": "プラン",
  "admin_platform_audit": "プラットフォーム監査",
  "admin_portal_toggle": "ポータル管理",
  "admin_premium_users": "プレミアムユーザー",
  "admin_primary": "プライマリー",
  "admin_published_articles": "公開済み記事",
  "admin_published_today": "今日公開",
  "admin_quick_actions": "クイックアクション",
  "admin_recent_articles": "最近の記事",
  "admin_role_change_failed": "役割の更新に失敗しました。",
  "admin_search_placeholder": "管理を検索...",
  "admin_secondary": "セカンダリー",
  "admin_seo_desc": "コンテンツの最適化、GSCとサイトマップの管理",
  "admin_seo_title": "SEOダッシュボード",
  "admin_service_requests": "サービスリクエスト",
  "admin_set_category": "カテゴリを設定",
  "admin_set_featured": "注目に設定",
  "admin_settings_saved": "設定が保存されました",
  "admin_settings_title": "設定",
  "admin_short_desc": "短い説明",
  "admin_site_identity": "サイトアイデンティティ",
  "admin_site_logo": "サイトロゴ",
  "admin_site_settings": "サイト設定",
  "admin_sponsored_marketplace": "スポンサー付きマーケットプレイス",
  "admin_sponsored_title": "スポンサー記事",
  "admin_surveys_title": "アンケート",
  "admin_system_status": "システムステータス",
  "admin_table_header_actions": "アクション",
  "admin_table_header_date": "日付",
  "admin_table_header_email": "メール",
  "admin_table_header_name": "名前",
  "admin_table_header_status": "ステータス",
  "admin_thumbnail_settings_saved": "サムネイル設定が保存されました",
  "admin_top_articles_views": "ビューによるトップ記事",
  "admin_total_articles": "総記事数",
  "admin_total_users": "総ユーザー数",
  "admin_total_views": "総閲覧数",
  "admin_ugc_review": "UGCレビュー",
  "admin_username": "ユーザー名",
  "admin_users_title": "ユーザー",
  "admin_version_history": "バージョン履歴",
  "admin_view_health_report": "完全な健康レポートを表示",
  "admin_write_new_article": "新しい記事を書く",
  "adsense_client_id": "AdSense クライアント ID",
  "adsense_enable_disable": "すべての自動広告配信を有効/無効にする",
  "adsense_global_toggle": "AdSense グローバルトグル",
  "adsense_script_code": "AdSense スクリプトコード",
  "adsense_settings": "AdSense & 広告位置設定",
  "advertise_contact_sales": "営業に連絡",
  "advertise_get_started": "始める",
  "advertise_reach_audience": "私たちの視聴者に届く",
  "advertise_title": "広告をご希望の方",
  "advertiser": "広告主",
  "advertiser_analytics": "広告主の分析",
  "advertiser_email": "広告主のメール",
  "advertising": "広告",
  "advertising_cookies": "広告クッキー",
  "affiliate_title": "アフィリエイトプログラム",
  "ago": "前",
  "ai_image_prompt": "AI画像プロンプト",
  "all": "すべて",
  "all_categories": "すべてのカテゴリ",
  "all_jobs": "全求人",
  "all_rights": "全著作権所有",
  "all_status": "すべてのステータス",
  "all_types": "すべてのタイプ",
  "alpha": "アルファ",
  "alreadyHaveAccount": "すでにアカウントをお持ちですか？",
  "already_have_account": "アカウントをお持ちですか？",
  "analytics": "分析",
  "analytics_cookies": "分析クッキー",
  "api_key": "APIキー",
  "api_secret": "APIシークレット",
  "applications": "応募",
  "apply": "適用",
  "apply_now": "今すぐ応募",
  "approve": "承認",
  "approved": "承認済み",
  "archive": "アーカイブ",
  "archived": "アーカイブ済み",
  "article_content": "記事の内容",
  "article_title": "記事のタイトル...",
  "article_views": "ビュー",
  "author": "著者",
  "auto_posting": "自動投稿とソーシャル統合",
  "auto_share_articles": "公開された記事を接続されたプラットフォームで自動的に共有する",
  "avg_ctr": "平均CTR",
  "back": "戻る",
  "basic": "基本",
  "be_respectful": "他のユーザーおよび記事の対象に対して敬意と礼節を持ちましょう",
  "beta": "ベータ",
  "book_ad": "広告を予約",
  "booking_details": "予約の詳細",
  "breaking": "速報",
  "bug_description": "バグの説明",
  "business": "ビジネス",
  "business_account_id": "ビジネスアカウントID",
  "buyer": "買い手",
  "campaign_details": "キャンペーンの詳細",
  "campaigns": "キャンペーン",
  "cancel": "キャンセル",
  "caption": "キャプション",
  "categories": "カテゴリ",
  "category": "カテゴリー",
  "category_distribution": "カテゴリ分布",
  "category_push_subscribers": "カテゴリー プッシュ購読者",
  "chatbot_placeholder": "メッセージを入力...",
  "chatbot_send": "送信",
  "chatbot_title": "チャットアシスタント",
  "choose_plan": "プランを選択",
  "city": "市",
  "classifieds": "広告",
  "classifieds_title": "クラシファイド",
  "clear": "クリア",
  "click_rate": "クリック率",
  "click_url": "クリックURL（目的地）",
  "clicks": "クリック",
  "client_id": "クライアントID",
  "client_secret": "クライアントシークレット",
  "close": "閉じる",
  "code": "コード",
  "commenting_rules": "コメントのルール",
  "comments": "コメント",
  "companies": "企業",
  "company": "会社",
  "compose_social_post": "ソーシャル投稿を作成する",
  "configure": "設定",
  "configure_position": "各ポジションをカスタムバナー画像または広告コードで設定する",
  "confirm": "確認",
  "confirm_delete": "削除してもよろしいですか？",
  "confirm_password": "パスワード確認",
  "congratulations": "おめでとうございます",
  "contact": "お問い合わせ",
  "contact_title": "連絡先",
  "contact_us": "お問い合わせ",
  "content": "コンテンツ",
  "cookies": "クッキー",
  "cookies_title": "クッキーポリシー",
  "copy": "コピー",
  "copyright": "著作権",
  "copyright_notice": "著作権",
  "count": "数",
  "country": "国",
  "cpm": "CPM",
  "create": "作成",
  "create_first_ad": "最初の広告を作成",
  "crypto_change_24h": "24時間変動",
  "crypto_market_cap": "時価総額",
  "crypto_price": "価格",
  "crypto_widget_title": "暗号",
  "ctr": "CTR",
  "culture": "文化",
  "current_plan": "現在のプラン",
  "custom_ad_code": "カスタム広告コード",
  "custom_banner_url": "カスタムバナーURL",
  "custom_range": "カスタム範囲",
  "daily_budget": "日次予算",
  "daily_performance": "日次パフォーマンス",
  "dark_mode": "ダークモード",
  "data_viz_title": "データ可視化",
  "date": "日付",
  "dating_add_video": "短いビデオを追加して、見込みのある相手があなたをよりよく理解できるようにしましょう",
  "dating_block": "ブロック",
  "dating_boosts": "ブースト",
  "dating_city": "都市",
  "dating_next": "次へ",
  "dating_personality_quiz": "性格診断",
  "dating_quiz_completed": "性格診断が完了しました",
  "dating_users": "ユーザー",
  "dating_verify_identity": "本物の人物であることを確認してください",
  "dating_voice_message": "ボイスメッセージ",
  "days": "日",
  "delete": "削除",
  "delete_failed": "削除に失敗しました。",
  "deleted_successfully": "正常に削除されました",
  "deprecated": "非推奨",
  "describe_thumbnail": "生成するサムネイル画像を説明...",
  "description": "説明",
  "deselect_all": "全て選択解除",
  "desktop": "デスクトップ",
  "details": "詳細",
  "dimensions": "寸法",
  "disabled": "無効",
  "dismiss": "却下",
  "documentation": "ドキュメント",
  "doktor_add_document": "書類を追加",
  "doktor_biography": "経歴",
  "doktor_birth_date": "生年月日",
  "doktor_chat": "チャット",
  "doktor_control_date": "管理日付",
  "doktor_date": "日付",
  "doktor_diagnosis": "診断",
  "doktor_enter_name_specialization": "名前と少なくとも一つの専門を入力",
  "doktor_enter_patient_name": "患者名を入力",
  "doktor_license_number": "ライセンス番号",
  "doktor_panel": "ドクターパネル",
  "doktor_patient_name": "患者名",
  "doktor_text_min_chars": "テキストは少なくとも50文字必要です",
  "doktor_waiting_room": "待合室",
  "dont_have_account": "アカウントがありませんか？",
  "download": "ダウンロード",
  "draft": "下書き",
  "duplicate": "複製",
  "duration_days": "期間（日）",
  "economy": "経済",
  "edit": "編集",
  "electronics": "電子機器",
  "email": "メール",
  "email_address": "メールアドレス",
  "email_campaigns": "メールキャンペーン",
  "email_clicks": "メールクリック",
  "email_content": "メール内容...",
  "email_opens": "メール開封",
  "email_placeholder": "メールアドレス",
  "email_subject": "メール件名",
  "employer": "雇用者",
  "enabled": "有効",
  "end_date": "終了日",
  "enter_advertiser_email": "広告主のメールを入力...",
  "enter_email_to_view": "上記に広告主のメールを入力してキャンペーンのパフォーマンスを表示",
  "entertainment": "エンターテイメント",
  "error": "エラー",
  "error_deleting": "削除エラー",
  "error_generating_digest": "ダイジェストの生成エラー",
  "error_loading": "読み込みエラー",
  "error_saving": "保存エラー",
  "error_saving_settings": "保存エラー",
  "error_sending": "送信エラー",
  "error_uploading": "アップロードエラー",
  "error_uploading_photo": "写真のアップロードに失敗しました",
  "events_calendar": "イベントカレンダー",
  "excerpt_summary": "抜粋 / 要約",
  "experimental": "実験的",
  "export": "エクスポート",
  "export_data": "データをエクスポート",
  "facebook": "Facebook",
  "facebook_login_unavailable": "Facebookログインは利用できません",
  "failed_post_comment": "コメントの投稿に失敗しました。",
  "feature_flags": "機能フラグ",
  "feature_job": "特集の仕事",
  "featured": "注目",
  "featured_article": "注目の記事",
  "featured_duration": "特集の期間",
  "featured_image": "注目の画像",
  "featured_jobs": "注目の求人",
  "feedback": "フィードバック",
  "filter": "フィルター",
  "filter_terms_saved": "フィルター条件が保存されました！",
  "find_jobs": "求人検索",
  "first": "最初",
  "first_process_publish": "まずは記事を処理して発行",
  "footer_ai": "このポータルはAIを活用しています",
  "footer_ai_notice": "一部のコンテンツはAIの支援を受けて作成されました - 問題を報告",
  "footer_cat_business": "ビジネス",
  "footer_cat_culture": "文化",
  "footer_cat_health": "健康",
  "footer_cat_news": "ニュース",
  "footer_cat_politics": "政治",
  "footer_cat_sports": "スポーツ",
  "footer_cat_technology": "テクノロジー",
  "footer_categories": "カテゴリー",
  "footer_copyright": "2026 Liber Nostra d.o.o. 無断転載を禁じます。",
  "footer_description": "Croatia Timesは、クロアチアおよびその他の地域からの速報ニュース、詳細な分析、魅力的なストーリーの信頼できる情報源です。",
  "footer_developed_by": "愛を込めて開発および管理されました",
  "footer_email_placeholder": "あなたのメールアドレス",
  "footer_here": "こちら",
  "footer_hosted_by": "ホスティング提供者",
  "footer_link_about": "私たちについて",
  "footer_link_advertise": "広告",
  "footer_link_contact": "連絡先",
  "footer_link_cookies": "クッキー",
  "footer_link_imprint": "インプリント",
  "footer_link_privacy": "プライバシーポリシー",
  "footer_link_submit_news": "ニュースを提出する",
  "footer_newsletter_text": "ニュースレターを購読する",
  "footer_quick_links": "クイックリンク",
  "footer_stay_informed": "最新情報を得る",
  "footer_subscribe": "購読する",
  "for_you_personalized": "あなたの興味に基づいたパーソナライズされたコンテンツ",
  "for_you_title": "あなたのために",
  "forgot_password": "パスワードを忘れた？",
  "free": "無料",
  "free_plan": "無料",
  "from": "から",
  "full_time": "正社員",
  "general": "一般",
  "goodbye": "さようなら",
  "hashtags": "ハッシュタグ",
  "hashtags_placeholder": "#news #croatia...",
  "header_auto_schedule_active": "自動スケジュール有効",
  "header_forecast": "予報",
  "header_humidity": "湿度",
  "header_live": "ライブ",
  "header_portals_label": "ポータル",
  "header_weather_humidity": "湿度",
  "header_weather_wind": "風",
  "header_wind": "風",
  "health": "健康",
  "hello": "こんにちは",
  "help": "ヘルプ",
  "home": "ホーム",
  "home_podcast_title": "週間技術まとめ：クロアチアのスタートアップにおけるAI",
  "home_video_title": "ザグレブ探訪：ストリートアートのドキュメンタリー",
  "hours": "時間",
  "import": "インポート",
  "impressions": "表示回数",
  "imprint": "インプリント",
  "imprint_title": "インプリント",
  "inactive": "非アクティブ",
  "info": "情報",
  "instagram": "Instagram",
  "invalid_code": "無効なコードです。再試行してください。",
  "items_selected": "項目が選択されました",
  "job_categories": "求人カテゴリ",
  "job_postings": "求人投稿",
  "job_seeker": "求職者",
  "jobs": "求人",
  "just_now": "たった今",
  "language": "言語",
  "last": "最後",
  "latest_news": "最新ニュース",
  "legal": "法的",
  "lifestyle": "ライフスタイル",
  "lifetime": "生涯",
  "light_mode": "ライトモード",
  "linked_email_campaign": "メールキャンペーンにリンクされている",
  "linkedin": "LinkedIn",
  "live_stream": "ライブストリーム",
  "load_more": "さらに読み込む",
  "loading": "読み込み中...",
  "local": "ローカル",
  "location": "場所",
  "login": "ログイン",
  "logout": "ログアウト",
  "loyalty_available_points": "利用可能なポイント",
  "loyalty_available_rewards": "利用可能な報酬",
  "loyalty_badges": "バッジ",
  "loyalty_consecutive_days": "連続日数",
  "loyalty_error": "エラー",
  "loyalty_leaderboard": "リーダーボード",
  "loyalty_leaderboard_empty": "リーダーボードは空です",
  "loyalty_rewards": "報酬",
  "loyalty_used_rewards": "使用済みの報酬",
  "majstor_categories": "カテゴリ",
  "majstor_city": "都市",
  "majstor_company_name": "会社名 *",
  "majstor_flexible": "フレキシブル",
  "majstor_max_budget": "最大予算 (EUR)",
  "majstor_min_budget": "最小予算 (EUR)",
  "majstor_my_requests": "私のリクエスト",
  "majstor_request_title": "リクエストタイトル *",
  "majstor_service_categories": "サービスカテゴリ",
  "majstor_urgent": "緊急",
  "manage": "管理",
  "manage_bookings": "広告主の予約を管理",
  "mark_as_read": "既読にする",
  "marketing_dashboard": "マーケティングダッシュボード",
  "marketing_live_metrics": "Croatia Timesのライブパフォーマンス指標",
  "marketing_published_articles": "公開記事",
  "marketing_registered_users": "登録ユーザー",
  "marketing_today_views": "今日のビュー",
  "marketing_total_views": "総ページビュー",
  "minutes": "分",
  "missing_translations": "欠けている翻訳",
  "mobile": "モバイル",
  "more": "もっと",
  "most_popular": "最も人気",
  "most_read": "最も読まれた",
  "move": "移動",
  "must_be_logged_in_purchase": "記事を購入するにはログインしている必要があります",
  "myProfile": "マイプロフィール",
  "my_applications": "応募履歴",
  "name": "名前",
  "new": "新しい",
  "new_article": "新しい記事",
  "new_campaign": "新しいキャンペーン",
  "new_notification": "新しい通知",
  "new_push_notification": "新しいプッシュ通知",
  "new_verification_sent": "新しい認証コードがメールに送信されました。",
  "news": "ニュース",
  "newsletter": "ニュースレター",
  "newsletter_desc": "最新ニュースを購読",
  "newsletter_only_subscribers": "購読者のみ",
  "newsletter_subscribers": "ニュースレター購読者",
  "next": "次へ",
  "no": "いいえ",
  "noAccount": "アカウントをお持ちではありませんか？",
  "no_articles": "記事が見つかりません",
  "no_bookings": "予約が見つかりません",
  "no_campaigns": "キャンペーンなし",
  "no_data": "データがありません",
  "no_items": "アイテムが見つかりません",
  "no_linked_campaign": "リンクされたキャンペーンなし",
  "no_notifications": "通知なし",
  "no_results": "結果なし",
  "no_scheduled_posts": "予定されている投稿はまだありません",
  "no_sent_notifications": "送信された通知なし",
  "none": "なし",
  "note": "メモ",
  "notification_body": "通知本文",
  "notification_title": "通知タイトル",
  "notifications": "通知",
  "of": "の",
  "off": "オフ",
  "offline": "オフライン",
  "on": "オン",
  "one_time": "一回",
  "online": "オンライン",
  "open_rate": "開封率",
  "optional": "任意",
  "options": "オプション",
  "orContinueWith": "または続行",
  "or_continue_with": "または以下で続行",
  "order": "注文",
  "other": "その他",
  "page": "ページ",
  "part_time": "パートタイム",
  "password": "パスワード",
  "paste": "貼り付け",
  "pause": "一時停止",
  "payment_error": "支払いエラー",
  "payment_processing": "支払い処理中...",
  "payment_success": "支払い成功!",
  "payment_thank_you": "ご購入ありがとうございます！",
  "pending": "保留中",
  "pending_approval": "承認待ち",
  "per_month": "/月",
  "per_page": "ページ毎",
  "percentage": "パーセンテージ",
  "performance": "パフォーマンス",
  "phone": "電話",
  "platforms": "プラットフォーム",
  "politics": "政治",
  "poll_results": "結果",
  "poll_total_votes": "総投票数",
  "poll_vote": "投票",
  "popular": "人気",
  "post_comment": "コメントを投稿",
  "post_error": "投稿エラー",
  "post_job": "求人投稿",
  "post_now": "今すぐ投稿",
  "powered_by": "提供",
  "premium": "プレミアム",
  "preview": "プレビュー",
  "previous": "前へ",
  "price": "価格",
  "privacy": "プライバシー",
  "privacy_title": "プライバシーポリシー",
  "proceed_to_payment": "支払いに進む",
  "profile": "プロフィール",
  "profile_admin_access": "管理者クイックアクセス",
  "profile_analytics": "分析",
  "profile_articles": "記事",
  "profile_dashboard": "ダッシュボード",
  "profile_edit": "プロフィール編集",
  "profile_verified": "プロフィールが確認されました！",
  "promo_success": "プロモコードが正常に適用されました！",
  "promote_job": "仕事を促進する",
  "publish": "公開",
  "published": "公開日",
  "published_date": "発行日",
  "push_notifications": "プッシュ通知",
  "read": "既読",
  "read_more": "続きを読む",
  "real_estate": "不動産",
  "recent": "最新",
  "recipes_add_first": "最初のレシピを追加",
  "recipes_browse_all": "すべてのレシピを見る",
  "recipes_category": "カテゴリー",
  "recipes_cook_time": "調理時間",
  "recipes_easy": "簡単",
  "recipes_featured": "おすすめレシピ",
  "recipes_filters": "フィルター",
  "recipes_ingredient": "材料",
  "recipes_ingredients": "材料",
  "recipes_instructions": "手順",
  "recipes_latest": "最新のレシピ",
  "recipes_most_popular": "人気のレシピ",
  "recipes_prep_time": "準備時間",
  "recipes_search": "レシピを検索...",
  "recipes_servings": "サービング",
  "recipes_title": "レシピ",
  "recommended": "推奨",
  "refresh": "更新",
  "region": "地域",
  "register": "登録",
  "reject": "拒否",
  "rejected": "却下",
  "related_articles": "関連記事",
  "remote": "リモート",
  "remove": "削除",
  "report": "レポート",
  "reports": "レポート",
  "reposting_rules_title": "転載ルール",
  "required": "必須",
  "reset": "リセット",
  "restore": "復元",
  "results": "結果",
  "resume": "再開",
  "revision_restored": "リビジョンが復元されました！",
  "salary": "給与",
  "salary_max": "最大給与",
  "salary_min": "最低給与",
  "save": "保存",
  "saved_jobs": "保存した求人",
  "saved_successfully": "正常に保存されました",
  "schedule": "スケジュール",
  "scheduled": "スケジュール済み",
  "science": "科学",
  "search": "検索...",
  "search_articles": "記事を検索...",
  "search_placeholder": "検索...",
  "search_results_for": "の検索結果",
  "seconds": "秒",
  "see_all": "すべて表示",
  "select": "選択",
  "select_all": "全て選択",
  "select_format": "形式を選択",
  "seller": "売り手",
  "send_campaign": "キャンペーンを送信",
  "sent": "送信済み",
  "sent_campaigns": "送信済みキャンペーン",
  "services": "サービス",
  "settings": "設定",
  "share": "共有",
  "showing": "表示中",
  "signIn": "サインイン",
  "signOut": "サインアウト",
  "site_name": "Croatia Times",
  "site_subtitle": "クロアチア・トゥデイ",
  "six_digit_code": "6桁のコード",
  "social_media": "ソーシャルメディア",
  "social_scheduler": "ソーシャルスケジューラー",
  "sort": "並べ替え",
  "sponsored_marketplace_title": "スポンサー付きマーケットプレイス",
  "sports": "スポーツ",
  "stable": "安定版",
  "start": "開始",
  "start_date": "開始日",
  "static_about_contact": "編集のお問い合わせ、広告や一般情報については、私たちの",
  "static_about_contact_page": "お問い合わせページ",
  "static_about_contact_title": "お問い合わせ",
  "static_about_lead": "Croatia Timesは、クロアチアとその地域の最新ニュース、分析、コメント、ストーリーをお届けする独立系ニュースポータルです。私たちはe-mina.euメディアファミリーの一員であり、同じチームと価値観を共有しています。",
  "static_about_mission": "私たちは、公的利益に貢献する正確でタイムリーかつ質の高いジャーナリズムを提供することに尽力しています。編集チームは、クロアチアおよび地域の事柄に深い知識を持つ経験豊富なジャーナリストで構成されています。",
  "static_about_mission_title": "私たちの使命",
  "static_about_publisher": "Liber Nostra d.o.o.は、Croatia Timesとe-mina.euの発行者です。この会社は、クロアチア市場に焦点を当てたデジタルメディアとニュースポータルを専門としています。",
  "static_about_publisher_title": "発行者",
  "static_about_standards": "Croatia Timesは最高のジャーナリズム基準を遵守しています。私たちは報告をファクトチェックし、コメントと分析を明確に示し、エラーがあれば迅速かつ透明に訂正します。",
  "static_about_standards_title": "編集基準",
  "static_about_team": "Croatia Timesの背後には、経験豊富なメディアプロフェッショナル、ジャーナリスト、編集者、技術者からなるチームがおり、プラットフォームの開発やコンテンツの品質に取り組んでいます。私たちのチームは、成功したポータルe-mina.eu - International News Agencyの背後にある同じチームです。",
  "static_about_team_title": "チーム",
  "static_about_title": "私たちについて - Croatia Times",
  "static_bug_description": "バグの説明",
  "static_bug_description_placeholder": "何が起こったか、どのように再現できるかを説明してください...",
  "static_bug_intro": "正しく動作しないものを見つけましたか？お知らせいただければ、迅速に修正します。",
  "static_bug_page_url": "ページURL(バグが発生した場所)",
  "static_bug_screenshot": "スクリーンショット(任意)",
  "static_bug_submit": "バグ報告を送信",
  "static_bug_submitting": "送信中...",
  "static_bug_thanks": "ご報告ありがとうございます！問題を調査し修正いたします。",
  "static_bug_title": "バグを報告する",
  "static_commenting_intro": "建設的な議論を歓迎します。コメントセクションをポジティブで生産的に保つために、以下のルールに従ってください：",
  "static_commenting_login": "コメントするにはCroatia Timesの登録とログインが必要です。",
  "static_commenting_rule_1": "他のユーザーや記事の対象に対して尊重し、礼儀正しく接してください",
  "static_commenting_rule_2": "ヘイトスピーチ、レイシズム、セクシズム、いかなる種類の差別も禁止",
  "static_commenting_rule_3": "スパム、広告、宣伝コンテンツは禁止",
  "static_commenting_rule_4": "誤報や未確認の主張の拡散は禁止",
  "static_commenting_rule_5": "個人攻撃や嫌がらせをしない",
  "static_commenting_rule_6": "テーマに沿って会話に貢献する",
  "static_commenting_rule_7": "第三者の個人情報や機密情報を記載しない",
  "static_commenting_title": "コメントルール",
  "static_commenting_violation": "これらのルールに違反するコメントは通知なしで削除される場合があります。繰り返し違反する場合は恒久的に禁止されることがあります。",
  "static_contact_email": "メール",
  "static_contact_message": "メッセージ",
  "static_contact_message_placeholder": "あなたのメッセージ...",
  "static_contact_name": "名前",
  "static_contact_name_placeholder": "あなたの名前",
  "static_contact_send": "メッセージを送る",
  "static_contact_sending": "送信中...",
  "static_contact_sent_desc": "24時間以内にご連絡いたします。",
  "static_contact_sent_title": "メッセージが送信されました！",
  "static_contact_subject": "件名",
  "static_contact_subject_placeholder": "どうお手伝いしましょうか？",
  "static_contact_title": "お問い合わせ",
  "static_cookies_advertising_text": "Google AdSenseクッキーを使用して、関連する広告を配信する場合があります。",
  "static_cookies_advertising_title": "広告クッキー",
  "static_cookies_analytics_text": "Google Analyticsは、訪問者がどのようにサイトを使用しているかを理解するのに役立ちます。可能な限りデータは匿名化されます。",
  "static_cookies_analytics_title": "分析クッキー",
  "static_cookies_managing_text": "ブラウザ設定でクッキーを管理できます。必要なクッキーを無効にすると、サイトの機能に影響することがあります。",
  "static_cookies_managing_title": "クッキー管理",
  "static_cookies_necessary_text": "サイトの機能に必要です（ログインセッション、テーマ設定）。無効にすることはできません。",
  "static_cookies_necessary_title": "必須クッキー",
  "static_cookies_title": "クッキーポリシー",
  "static_cookies_types_title": "使用するクッキーの種類",
  "static_cookies_what_text": "クッキーは、ウェブサイトを訪問したときにデバイスに置かれる小さなテキストファイルです。サイトがあなたの好みを記憶し、どのように使用するかを理解するのに役立ちます。",
  "static_cookies_what_title": "クッキーとは",
  "static_imprint_ads_email": "メール（広告）:",
  "static_imprint_ai_notice": "コンテンツの一部はAI技術を使用して生成されています。エラーや不適切なコンテンツを報告するには",
  "static_imprint_contact": "連絡先",
  "static_imprint_copyright": "著作権",
  "static_imprint_copyright_text": "Croatia Timesに公開されたすべてのコンテンツは著作権で保護されています。Liber Nostra d.o.o.は、このサイトに公開されたテキスト、画像、およびマルチメディアコンテンツに対するすべての権利を保持します。コンテンツ再投稿ルールの詳細情報は、",
  "static_imprint_ct_desc": "Croatia Timesニュースポータル",
  "static_imprint_disclaimer": "免責事項",
  "static_imprint_disclaimer_text": "コンテンツを注意深く管理しているにもかかわらず、外部リンクに対して責任を負いません。それらの運営者がその内容に対し単独で責任を負います。",
  "static_imprint_editorial_email": "メール（編集部）:",
  "static_imprint_emina_desc": "International News Agency",
  "static_imprint_general_email": "メール（一般問い合わせ）:",
  "static_imprint_last_updated": "最終更新日: 2026年2月",
  "static_imprint_or_via": "または私たちの経由で",
  "static_imprint_publisher": "発行者",
  "static_imprint_registered": "クロアチア共和国に登録",
  "static_imprint_reposting_page": "再投稿ルールページ",
  "static_imprint_responsible": "コンテンツの責任者",
  "static_imprint_responsible_text": "Croatia Times / Liber Nostra d.o.o.の編集チーム",
  "static_imprint_title": "インプリント",
  "static_imprint_websites": "ウェブサイト",
  "static_privacy_controller": "データ管理者：Liber Nostra d.o.o.",
  "static_privacy_cookies_text": "機能と分析のためにクッキーを使用しています。詳細はクッキーポリシーをご覧ください。",
  "static_privacy_cookies_title": "クッキー",
  "static_privacy_data_text": "名前、サインアップ時のメールなどの直接提供されたデータ、訪問したページ、読んだ記事などの使用データ、IPアドレス、ブラウザタイプなどの技術データを収集します。",
  "static_privacy_data_title": "収集するデータ",
  "static_privacy_last_updated": "最終更新日：2026年1月",
  "static_privacy_lead": "Croatia Timesは、あなたのプライバシーを尊重し、個人データの保護に努めています。",
  "static_privacy_retention_text": "アカウントがアクティブである限り、または法的目的で必要な限り、データを保持します。",
  "static_privacy_retention_title": "データ保持",
  "static_privacy_rights_text": "個人データにアクセス、修正、削除する権利があります。お問い合わせは",
  "static_privacy_rights_title": "あなたの権利",
  "static_privacy_title": "プライバシーポリシー",
  "static_privacy_usage_text": "私たちはあなたのデータを使用して、ニュースサービスを提供し、体験をパーソナライズし、ニュースレターを送信（ご同意いただいた場合）、プラットフォームを改善します。",
  "static_privacy_usage_title": "データの利用方法",
  "static_reposting_copyright_text": "Croatia Timesに掲載されたすべてのコンテンツは著作権で保護されています。Liber Nostra d.o.o.がこのウェブサイトに掲載されたテキスト、画像、マルチメディアのすべての権利を保持します。",
  "static_reposting_copyright_title": "著作権",
  "static_reposting_permission_text": "コンテンツの再印刷許可を求めるには、",
  "static_reposting_permission_title": "許可リクエスト",
  "static_reposting_permitted_text": "ソーシャルメディアや他のプラットフォームで記事のリンクを共有できます。最大2段落の短い引用は、明確な帰属と元の記事へのリンクを伴って使用できます。",
  "static_reposting_permitted_title": "許可された使用",
  "static_reposting_prohibited_text": "書面による許可なしに記事を全文転載することは禁止されています。許可なしに画像を再生することはできません。コンテンツの自動スクレイピングは厳格に禁止されています。",
  "static_reposting_prohibited_title": "禁止されている使用",
  "static_reposting_title": "再投稿ルール",
  "static_submit_news_details": "ストーリー詳細",
  "static_submit_news_details_placeholder": "ニュースを説明...",
  "static_submit_news_file_limit_error": "ファイルが制限を超えています",
  "static_submit_news_headline": "ニュース見出し",
  "static_submit_news_intro": "ニュースがある？ここに送信してください。編集チームがレビューします。",
  "static_submit_news_limit": "写真やビデオは最大",
  "static_submit_news_photos": "写真 / ビデオ (最大",
  "static_submit_news_send": "ニュースを送信",
  "static_submit_news_sending": "送信中...",
  "static_submit_news_source": "ソース / 参考（任意）",
  "static_submit_news_source_placeholder": "URLまたは参照",
  "static_submit_news_thanks": "送信いただきありがとうございます！我々のチームがすぐにレビューします。",
  "static_submit_news_title": "ニュースを投稿",
  "static_submit_news_your_name": "あなたの名前",
  "status": "ステータス",
  "stop": "停止",
  "submit": "送信",
  "submitNews": "ニュースを提出する",
  "submit_bug_title": "バグレポートを提出",
  "submit_news": "ニュース投稿",
  "submit_news_title": "ニュースを送信",
  "subscribe": "購読",
  "subscription": "サブスクリプション",
  "subscription_title": "サブスクリプションプラン",
  "success": "成功",
  "support": "サポート",
  "tablet": "タブレット",
  "tags": "タグ",
  "target_impressions": "目標インプレッション",
  "technology": "テクノロジー",
  "template": "テンプレート",
  "templates": "テンプレート",
  "terms": "利用規約",
  "thank_you": "ありがとうございます",
  "this_month": "今月",
  "this_week": "今週",
  "this_year": "今年",
  "tip": "ヒント",
  "title": "タイトル",
  "to": "まで",
  "today": "今日",
  "total": "合計",
  "translate_all": "すべて翻訳する",
  "translation_status": "翻訳状態",
  "translations": "翻訳",
  "travel": "旅行",
  "trending": "トレンド",
  "try_again": "再試行",
  "twitter": "Twitter",
  "two_factor_auth": "2要素認証",
  "type": "タイプ",
  "ugc_submit": "コンテンツを提出",
  "ugc_title": "市民ジャーナリズムポータル",
  "unique_clicks": "ユニーククリック数",
  "unique_opens": "ユニークオープン数",
  "unknown": "不明",
  "unpublish": "非公開",
  "unread": "未読",
  "update": "更新",
  "updated_successfully": "正常に更新されました",
  "upgrade": "アップグレード",
  "upload": "アップロード",
  "users": "ユーザー",
  "vehicles": "車両",
  "verification_code_sent": "認証コードがメールに送信されました！",
  "version": "バージョン",
  "vibeposao": "Times Posao",
  "view": "表示",
  "view_all": "すべて表示",
  "views": "閲覧数",
  "warning": "警告",
  "welcome": "ようこそ",
  "wish_roles": "希望職種",
  "working_hours_saved": "勤務時間が保存されました！",
  "world": "国際",
  "write_new_article": "新しい記事を書く",
  "yes": "はい",
  "yesterday": "昨日",
  "your_bookings": "あなたの予約",
  "youtube": "YouTube"
}
